import { useAuth } from '@/stores/authStore'
import { Sidebar, SidebarContent, SidebarFooter } from '@/components/ui/sidebar'
import { NavGroup } from '@/components/layout/nav-group'
import { adminSidebarData } from './admin-sidebar-data'
import { NavAdmin } from './nav-admin'

export function AdminAppSidebar({
  ...props
}: React.ComponentProps<typeof Sidebar>) {
  const auth = useAuth()

  // Create user object from auth data
  const user = {
    name: auth.user?.fullName || 'Admin User',
    email: auth.user?.email || 'admin@example.com',
    avatar: auth.user?.avatarUrl || '/avatars/admin.jpg',
    firstName: auth.user?.firstName || 'Admin',
    lastName: auth.user?.lastName || 'User',
  }

  return (
    <Sidebar collapsible='icon' variant='floating' {...props}>
      <SidebarContent>
        {adminSidebarData.navGroups.map((group) => (
          <NavGroup key={group.title} {...group} />
        ))}
      </SidebarContent>
      <SidebarFooter>
        <NavAdmin user={user} />
      </SidebarFooter>
      {/* <SidebarRail /> */}
    </Sidebar>
  )
}
